import { render, staticRenderFns } from "./SignUpComponent.vue?vue&type=template&id=6a41de36&scoped=true&"
import script from "./SignUpComponent.vue?vue&type=script&lang=js&"
export * from "./SignUpComponent.vue?vue&type=script&lang=js&"
import style0 from "./SignUpComponent.vue?vue&type=style&index=0&id=6a41de36&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a41de36",
  null
  
)

export default component.exports